<template>
  <div class="toolbar">
    <div class="col-1 float-right">
      <new-menu-app></new-menu-app>
    </div>
    <back-icon></back-icon>
    <search-icon></search-icon>
    <div class="col-4 float-left">
      <a href="/home">
        <v-img
            :src="require('../assets/logohome.png')"

            contain
            height="35"
        />
      </a>
    </div>
  </div>
  <v-main class="main">
<!--    <new-products></new-products>-->
    <new-products :category="$route.params.id" :category_name="$route.params.name"></new-products>
    <footer-app :selectedItem="null"></footer-app>
    <div class="clearfix"></div>
  </v-main>
</template>

<script>
import { defineComponent } from 'vue';
import HelloWorld from '../components/HelloWorld.vue';
import AboutView from "@/views/AboutView.vue";
import HeaderApp from "@/views/headerApp.vue";
import PicLink from "@/components/PicLink.vue";
import FooterApp from "@/views/FooterApp.vue";
import Category from "@/components/Category.vue";
import Products from "@/components/Products.vue";
import NewProducts from "@/components/NewProducts.vue";
import NewMenuApp from "@/components/newMenuApp.vue";
import searchIcon from "@/components/searchIcon.vue";
import BackIcon from "@/components/backIcon.vue";

export default defineComponent({
  name: 'Product-view',

  components: {
    BackIcon,
    NewMenuApp,
    NewProducts,
    Products,
    Category,
    FooterApp,
    PicLink,
    HeaderApp,
    HelloWorld,
    searchIcon
  },
});
</script>

<style scoped>
.toolbar{
  width: 100%;
  height: 60px;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1000000;
  direction: rtl;
  padding: 20px 30px;
  color: #fff;
  background: #fff;
}
.toolbar i{
  font-size: 24pt;
  color: #1fa29d;
}
.toolbar .col-9{
  padding-right: 10px;
}
.main{
  padding: 60px 20px 60px;
  height: calc(100% +100px);
}
</style>
